"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductOfferingById = exports.getProductCatalogHandsetList = exports.getProductCatalogBrandNameList = exports.filterProductCatalogUnavailableHandesets = exports.filterProductCatalogEmptyBrands = void 0;
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _lodash2 = _interopRequireDefault(require("lodash.uniq"));
var _services = require("../services");
var _logger = require("../services/logger");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getProductCatalogHandsetList = productOffering => {
  return (0, _lodash.default)(productOffering.map((handset, index) => {
    var _handset$productSpeci, _handset$productSpeci2, _handset$productSpeci3, _handset$productSpeci4;
    return {
      id: index,
      model: (_handset$productSpeci = handset.productSpecification.productSpecCharacteristic.find(characteristic => {
        return characteristic.name === 'model';
      })) === null || _handset$productSpeci === void 0 ? void 0 : (_handset$productSpeci2 = _handset$productSpeci.productSpecCharacteristicValue[0]) === null || _handset$productSpeci2 === void 0 ? void 0 : _handset$productSpeci2.value,
      brand: (_handset$productSpeci3 = handset.productSpecification.productSpecCharacteristic.find(characteristic => {
        return characteristic.name === 'brand';
      })) === null || _handset$productSpeci3 === void 0 ? void 0 : (_handset$productSpeci4 = _handset$productSpeci3.productSpecCharacteristicValue[0]) === null || _handset$productSpeci4 === void 0 ? void 0 : _handset$productSpeci4.value
    };
  }), handset => handset.model);
};
exports.getProductCatalogHandsetList = getProductCatalogHandsetList;
const getProductCatalogBrandNameList = productOffering => {
  return (0, _lodash2.default)(productOffering.map(handset => {
    var _handset$productSpeci5, _handset$productSpeci6, _handset$productSpeci7;
    return (_handset$productSpeci5 = handset.productSpecification.productSpecCharacteristic.find(characteristic => {
      return characteristic.name === 'brand';
    })) === null || _handset$productSpeci5 === void 0 ? void 0 : (_handset$productSpeci6 = _handset$productSpeci5.productSpecCharacteristicValue[0]) === null || _handset$productSpeci6 === void 0 ? void 0 : (_handset$productSpeci7 = _handset$productSpeci6.value) === null || _handset$productSpeci7 === void 0 ? void 0 : _handset$productSpeci7.toLowerCase();
  }).filter(brand => brand));
};
exports.getProductCatalogBrandNameList = getProductCatalogBrandNameList;
const filterProductCatalogEmptyBrands = productOffering => {
  return productOffering.filter(handset => {
    var _handset$productSpeci8, _handset$productSpeci9, _handset$productSpeci10;
    return ((_handset$productSpeci8 = handset.productSpecification.productSpecCharacteristic) === null || _handset$productSpeci8 === void 0 ? void 0 : (_handset$productSpeci9 = _handset$productSpeci8.find(characteristic => {
      return characteristic.name === 'brand';
    })) === null || _handset$productSpeci9 === void 0 ? void 0 : (_handset$productSpeci10 = _handset$productSpeci9.productSpecCharacteristicValue[0]) === null || _handset$productSpeci10 === void 0 ? void 0 : _handset$productSpeci10.value) !== undefined;
  });
};
exports.filterProductCatalogEmptyBrands = filterProductCatalogEmptyBrands;
const filterProductCatalogUnavailableHandesets = productOffering => {
  return productOffering.filter(handset => {
    var _handset$prodSpecChar, _handset$prodSpecChar2;
    return ((_handset$prodSpecChar = handset.prodSpecCharValueUse.find(characteristic => {
      return characteristic.name === 'stockAvailability';
    })) === null || _handset$prodSpecChar === void 0 ? void 0 : (_handset$prodSpecChar2 = _handset$prodSpecChar.productSpecCharacteristicValue[0]) === null || _handset$prodSpecChar2 === void 0 ? void 0 : _handset$prodSpecChar2.value) === true;
  });
};
exports.filterProductCatalogUnavailableHandesets = filterProductCatalogUnavailableHandesets;
const getProductOfferingById = async id => {
  try {
    const res = await _services.Services.http.get(`/productCatalog/v4/productOffering/${id}?expand=productOfferingPrice`);
    return res;
  } catch (error) {
    _logger.Logger.error({
      segments: [_logger.Logger.LOGGER_SEGMENTS.UTILS]
    })('Cannot get default product by ID', error);
  }
};
exports.getProductOfferingById = getProductOfferingById;